const stripHtml = (value) => String(value).replace(/<\/?[^>]+(>|$)/g, "");

const cleanMetaText = (value) => value == null
    ? ""
    : stripHtml(value).replace(/\n/g, "");

const absoluteUrl = (url) => {
    if (!url) return "";
    return /^https?:\/\//.test(url) ? url : `https://${url}`;
};

const portfolioBaseUrl = (portfolio) => portfolio?.ownDomainAddress
    ? absoluteUrl(portfolio.ownDomainAddress)
    : `https://uxfol.io/${portfolio?.shortId || ""}`;

const projectUrl = (portfolio, project, route) => {
    if (!project?.shortId) return portfolioBaseUrl(portfolio);

    if (portfolio?.ownDomainAddress) {
        return `${absoluteUrl(portfolio.ownDomainAddress)}/p/${project.shortId}`;
    }

    const portfolioShortId = route?.params?.portfolioShortId || portfolio?.shortId || "";
    return `https://uxfol.io/p/${portfolioShortId}/${project.shortId}`;
};

const portfolioRoutePath = (portfolio, route) => {
    const fullPath = route?.fullPath || "";
    const shortIdPrefix = `/${route?.params?.shortId || portfolio?.shortId || ""}`;

    if (fullPath === shortIdPrefix) return "";
    if (fullPath.startsWith(`${shortIdPrefix}/`)) return fullPath.slice(shortIdPrefix.length);
    return fullPath === "/" ? "" : fullPath;
};

export const buildPortfolioSocialHead = ({
    portfolio,
    project,
    user,
    route,
    useProjectSocialInfo = false,
}) => {
    const socialInfo = useProjectSocialInfo ? project?.settings?.socialInfo : portfolio?.settings?.socialInfo;
    const fallbackTitle = useProjectSocialInfo
        ? project?.name || user?.name || portfolio?.name || ""
        : portfolio?.name || user?.name || "";
    const fallbackDescription = useProjectSocialInfo
        ? project?.subtitle || user?.title || ""
        : portfolio?.description || user?.title || user?.description || "";
    const title = cleanMetaText(socialInfo?.title || fallbackTitle);
    const description = cleanMetaText(socialInfo?.subtitle || fallbackDescription);
    const imageUrl = socialInfo?.image?.url || "";
    const pageUrl = useProjectSocialInfo
        ? projectUrl(portfolio, project, route)
        : `${portfolioBaseUrl(portfolio)}${portfolioRoutePath(portfolio, route)}`;

    const meta = [
        {key: "description", name: "description", content: description},
        {key: "og:title", property: "og:title", content: title},
        {key: "og:description", property: "og:description", content: description},
        {key: "og:url", property: "og:url", content: pageUrl},
        {key: "twitter:title", name: "twitter:title", content: title},
        {key: "twitter:description", name: "twitter:description", content: description},
    ];

    if (portfolio?.settings?.searchEngineHidden) {
        meta.push({key: "robots", name: "robots", content: "noindex"});
    }

    if (imageUrl) {
        meta.push(
            {key: "og:image", property: "og:image", content: imageUrl},
            {key: "twitter:image", name: "twitter:image", content: imageUrl},
        );
    }

    return {
        title,
        meta,
    };
};
